import { defineMessages } from 'react-intl';

import { useManagerTaskContext } from '@sorare/core/src/contexts/managerTask';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

import coverDesktop from 'components/market/assets/auctions_desktop.jpg';
import cover from 'components/market/assets/auctions_mobile.jpg';
import { useCurrentMarketplaceUserContext } from 'contexts/currentMarketplaceUser';

import { OneTimeOnboardingDialog as OnboardingDialog } from '..';

const messages = defineMessages({
  title: {
    id: 'NewsSigningsOnboardingDialog.title',
    defaultMessage: 'New card auctions',
  },
  description: {
    id: 'NewsSigningsOnboardingDialog.description',
    defaultMessage:
      'Bid on cards in auctions to take a chance at becoming the first owner of those new Sorare cards',
  },
});

export const NewsSignings = ({
  open,
  onClick,
}: {
  open: boolean;
  onClick: () => void;
}) => {
  const { wonTokenAuctions } = useCurrentMarketplaceUserContext();

  const { task } = useManagerTaskContext();

  return (
    <OnboardingDialog
      title={messages.title}
      description={messages.description}
      img={cover}
      imgDesktop={coverDesktop}
      lifecycleKey={LIFECYCLE.sawMarketplaceOnboarding}
      show={wonTokenAuctions?.hasAny === false && !task}
      open={open}
      onClick={onClick}
    />
  );
};
